// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICipInfoMetricsResponseDto
 */
export interface ICipInfoMetricsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ICipInfoMetricsResponseDto
     */
    passed?: number;
    /**
     * 
     * @type {number}
     * @memberof ICipInfoMetricsResponseDto
     */
    pending?: number;
    /**
     * 
     * @type {number}
     * @memberof ICipInfoMetricsResponseDto
     */
    failed?: number;
}

/**
 * Check if a given object implements the ICipInfoMetricsResponseDto interface.
 */
export function instanceOfICipInfoMetricsResponseDto(value: object): value is ICipInfoMetricsResponseDto {
    return true;
}

export function ICipInfoMetricsResponseDtoFromJSON(json: any): ICipInfoMetricsResponseDto {
    return ICipInfoMetricsResponseDtoFromJSONTyped(json, false);
}

export function ICipInfoMetricsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICipInfoMetricsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'passed': json['passed'] == null ? undefined : json['passed'],
        'pending': json['pending'] == null ? undefined : json['pending'],
        'failed': json['failed'] == null ? undefined : json['failed'],
    };
}

export function ICipInfoMetricsResponseDtoToJSON(json: any): ICipInfoMetricsResponseDto {
    return ICipInfoMetricsResponseDtoToJSONTyped(json, false);
}

export function ICipInfoMetricsResponseDtoToJSONTyped(value?: ICipInfoMetricsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'passed': value['passed'],
        'pending': value['pending'],
        'failed': value['failed'],
    };
}

